import { render } from "./ConsultationModal.vue?vue&type=template&id=12ee9ff3&scoped=true"
import script from "./ConsultationModal.vue?vue&type=script&lang=js"
export * from "./ConsultationModal.vue?vue&type=script&lang=js"

import "./ConsultationModal.vue?vue&type=style&index=0&id=12ee9ff3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ee9ff3"]])

export default __exports__